import React from "react";
import Button from "../../../component/button/Button";

interface FormButtonsProps {
    screenShort: any;
    flkState: any;
    showEditFlkForm: () => void;
    updateValudatesetFormstatus: (val: string) => void;
    updateFormData: any[];
    ress: any;
    formik: any;
    candidateData: any;
}

const FormButtons: React.FC<FormButtonsProps> = ({
    screenShort,
    flkState,
    showEditFlkForm,
    updateValudatesetFormstatus,
    updateFormData,
    ress,
    formik,
    candidateData
}) => {
    if (!screenShort.active) { return null; }
    const SIGN_BTN = "Continue To Signature Step";
    const NEXT_BTN = "Continue To Next Step";

    let isCurrentFlkForm = false;
    if(flkState.type !== null) {
        isCurrentFlkForm = flkState.formIndex === ress.index;
    }
    const isEditing = flkState.signingUrl.length > 0 || flkState.signedUrl?.length > 0;

    const handleClick = () => {
        updateValudatesetFormstatus("");
        const activeForm = updateFormData.find((f: any) => f.active);
        if (activeForm) {
            document.getElementById(`submitBtn_${activeForm.index}`)?.click();
        }
    };

    // ---- LABEL LOGIC (unified) ----
    const label = (() => {
        if (!isEditing) {
            if (isCurrentFlkForm && formik?.dirty) {
                return SIGN_BTN;
            }
            if (candidateData?.continueButtonText) {
                return NEXT_BTN;
            }
            if (flkState.hasChanges) {
                return SIGN_BTN;
            }
            return NEXT_BTN;
        }

        // If editing (iframe open or signed preview active)
        if (isEditing && isCurrentFlkForm) {
            return NEXT_BTN;
        }
        return SIGN_BTN;
    })();

    const editLabel = (() => {
        if (flkState.type === "TFN") {
            return "Edit TFN Form";
        } else if (flkState.type === "SUPER") {
            return "Edit Super Form";
        } else {
            if(flkState.formName){
                return "Edit "+flkState.formName+" Form";
            }else{
                return "Edit Form";
            }
        }
    })();

    return (
        <div className="btn-section">
            {isCurrentFlkForm && flkState.signingUrl.length > 0 && (
                <Button
                    onClick={showEditFlkForm}
                    type="button"
                    icon="pi pi-arrow-left"
                    position="right"
                    label={editLabel}
                    clasName="btn btn-primary check_tfn_form_btn"
                />
            )}

            <Button
                onClick={handleClick}
                type="button"
                icon="pi pi-arrow-right"
                position="right"
                clasName="btn btn-primary"
                label={label}
            />

            <Button
                id={`submitBtn_${ress.index}`}
                type="submit"
                icon="pi pi-arrow-right"
                position="right"
                clasName="d-none btn btn-primary"
                label=""
            />
        </div>
    );
};

export default FormButtons;
